import { logWrapper } from '../../utils';
import toastr from 'toastr';

export default {
    expiredDocumentModalController: [
        'runtimeConstant',
        '$scope',
        '$uibModalInstance',
        '$filter',
        'revision',
        function (runtimeConstant, $scope, $uibModalInstance, $filter, revision) {
            'use strict';

            $scope.revision = revision;
            $scope.dateOpened = false;
            $scope.saving = false;

            var interval =
                (revision.documentType && revision.documentType.revisionInterval) ||
                365;

            var suggested = new Date();
            suggested.setDate(suggested.getDate() + interval);
            suggested.setHours(0, 0, 0, 0);
            $scope.newNextRevisionDate = suggested;

            $scope.triggerDays =
                (revision.documentType && revision.documentType.revisionInterval) ||
                365;
            $scope.notificationDays =
                revision.notificationDays ||
                (revision.documentType && revision.documentType.notificationDays) ||
                30;

            function cancel() {
                $uibModalInstance.dismiss('cancel');
            }

            function isStillExpired(date) {
                if (!date) return true;

                var today = new Date();
                return today.getTime() > new Date(date).getTime();
            }

            function updateAndSave() {
                if (!$scope.newNextRevisionDate) {
                    toastr.warning($filter('translate')('SELECT_A_VALID_DATE'));
                    return;
                }

                if (isStillExpired($scope.newNextRevisionDate)) {
                    toastr.warning(
                        $filter('translate')('DATE_STILL_EXPIRED') ||
                        'A data escolhida ainda mantém o documento vencido. Escolha uma data futura.'
                    );
                    return;
                }

                $scope.saving = true;
                revision.nextRevisionDate = $scope.newNextRevisionDate;

                if (!revision.folder) {
                    revision.folder = {
                        Id: revision.idFolder
                    };
                }

                if (!revision.documentType) {
                    revision.documentType = {
                        Id: revision.idDocumentType,
                        RevisionInterval: $scope.triggerDays,
                        NotificationDays: $scope.notificationDays
                    };
                }

                if (!revision.idFolder) {
                    revision.idFolder = revision.folder.Id;
                }
                if (!revision.idDocumentType) {
                    revision.idDocumentType = revision.documentType.Id;
                }

                revision
                    .updateProperties()
                    .then(function (updated) {
                        if (updated) {
                            revision.nextRevisionDate = updated.nextRevisionDate;
                            revision.notificationDays = updated.notificationDays;
                        }
                        $uibModalInstance.close(true);
                    })
                    .catch(function (err) {
                        console.error(err);
                        $scope.saving = false;
                        toastr.error(
                            (err && err.error_description) ||
                            $filter('translate')('ERROR_UPDATING_EXPIRATION')
                        );
                    });
            }

            function forceUpdateProperties() {
                var payload = {
                    id: revision.id,
                    guid: revision.guid,
                    idAuthor: revision.idAuthor,
                    idCompany: revision.idCompany,
                    idDocumentType: revision.idDocumentType || (revision.documentType && (revision.documentType.Id || revision.documentType.id)) || 0,
                    idFolder: revision.idFolder || (revision.folder && (revision.folder.Id || revision.folder.id)) || 0,
                    idStatus: revision.idStatus,
                    revisionStatus: revision.revisionStatus,
                    code: revision.code,
                    title: revision.title,
                    description: revision.description || '',
                    revisionNumber: revision.revisionNumber,
                    date: revision.date,
                    extension: revision.extension,
                    nextRevisionDate: $scope.newNextRevisionDate,
                    notificationDays: revision.notificationDays || $scope.notificationDays,
                    size: revision.size,
                    isFavorite: revision.isFavorite,
                    numberOfPages: revision.numberOfPages,
                    propertiesIndexed: revision.propertiesIndexed,
                    contentIndexed: revision.contentIndexed,
                    features: revision.features || [],
                    revisionAdditionalFields: revision.revisionAdditionalFields || [],
                    // demais campos que o backend espera (pode ajustar conforme o curl)
                };

                revision
                    .updateProperties()
                    .then(function () {
                        $uibModalInstance.close(true);
                    })
                    .catch(function (e) {
                        $scope.saving = false;
                        toastr.error('Não foi possível atualizar o vencimento.');
                        console.error(e);
                    });
            }

            function run() {
                $scope.cancel = logWrapper(cancel, runtimeConstant.isDebugControllersInternals);
                $scope.updateAndSave = logWrapper(updateAndSave, runtimeConstant.isDebugControllersInternals);
            }

            logWrapper(run, runtimeConstant.isDebugControllers)();
        },
    ],
};